import styled from 'styled-components';

export const SpotlightContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2000;
  pointer-events: none;
`;

export const SpotlightMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important ;
  background: rgba(0, 0, 0, 0.6);
  pointer-events: auto;
`;

export const SpotlightOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  pointer-events: auto;
  z-index: 2001;
`;

export const SpotlightHole = styled.div`
  position: fixed;
  /* AJUSTE: pointer-events controla se a área destacada aceita cliques.
     'auto' = bloqueia cliques (o overlay captura). 
     Para permitir cliques no elemento abaixo, mude para 'none'. */
  pointer-events: auto;
  z-index: 2002;
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid #f39519;
    border-radius: 0.1rem;
  }
`;

export const ClickableArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: auto !important; // Permite que o clique seja capturado
  background: transparent;
  z-index: 4002;
`;
